import React, { useState } from "react";
import CommonSearchBox from "../SearchBox/CommomSearchBox";
import ConfirmBox from "../Popup/ConfirmBox";
import AddonCard from "./AddonCard";
import "./AddonMobileList.css";
import { useTranslation } from "react-i18next";
import EmptyScreen from "../common/EmptyScreen";

function AddonMobileList({ addonGroups = [], onEdit, onDelete }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [deleteId, setDeleteId] = useState("");

  const filteredGroups = (addonGroups || []).filter((g) =>
    g.groupName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="addon-mobile-container">
      <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Add-ons")} ({filteredGroups.length})</h3>

      <CommonSearchBox
        placeholder="Search add-on group..."
        search={search}
        setSearch={setSearch}
      />

      {filteredGroups.length === 0 ? (
        <EmptyScreen compact message="No add-on groups found." subText="Create an add-on group to offer extras and customisations." />
      ) : (
        <ul className="addon-card-list">
          {filteredGroups.map((group) => (
            <AddonCard
              key={group.addonGroupId}
              group={group}
              onEdit={onEdit}
              onDelete={(id) => setDeleteId(id)}
            />
          ))}
        </ul>
      )}

      <ConfirmBox
        variant="delete"
        isOpen={Boolean(deleteId)}
        title={"Are you sure you want to delete this Add-on Group?"}
        onConfirm={() => {
          if (deleteId) onDelete(deleteId);
        }}
        onCancel={() => setDeleteId("")}
      />
    </div>
  );
}

export default AddonMobileList;
